import React from 'react';
import { Share2 } from 'lucide-react';

export const InstantShare = ({ showInstantShare, shareData, setShowInstantShare, setShareData, shareToSocial }) => {
  if (!showInstantShare || !shareData) return null;

  return (
    <div className="fixed inset-0 z-[150] bg-black/90 flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-lime-500 to-green-600 border-4 border-lime-400 p-8 max-w-md w-full">
        <h2 className="text-3xl font-black text-black uppercase mb-4 text-center">
          {shareData.isRecovery ? '🔥 RECOVERY SEND! 🔥' : '✓ SENT IT!'}
        </h2>
        <p className="text-black font-bold text-center mb-2">
          +{shareData.points} points {shareData.isRecovery && '(2× RECOVERY!)'}
        </p>
        <p className="text-black/80 font-bold text-sm text-center mb-6">
          Want to brag?
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => {
              shareToSocial('challenge', { challenge: shareData.challenge });
              setShowInstantShare(false);
              setShareData(null);
            }}
            className="w-full bg-black text-lime-400 py-4 font-black text-xl uppercase border-3 border-lime-400 hover:bg-gray-900 transition-all flex items-center justify-center gap-2"
          >
            <Share2 size={24} />
            SHARE IT
          </button>
          <button
            onClick={() => {
              setShowInstantShare(false);
              setShareData(null);
            }}
            className="w-full bg-transparent text-black py-3 font-black text-base uppercase border-2 border-black hover:bg-black/10 transition-all"
          >
            NAH, I'M GOOD
          </button>
        </div>
      </div>
    </div>
  );
};
